import { useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import classNames from 'classnames'

import downArrow from '../../../assets/images/down-arrow.svg'
import styles from './DropdownFilter.module.scss'

function DropdownFilter({
  title,
  options = [],
  selectedOption = {},
  handleChange,
  selectedOptionKey,
  disabled,
  className,
  height = 24,
}) {
  const [isOpen, setIsOpen] = useState(false)
  const handleOptionChange = (e, option) => {
    if (handleChange) {
      handleChange(e, option, selectedOptionKey)
    }
    setIsOpen(false)
  }
  return (
    <div className={styles.container}>
      <span className={styles.filterTitle}>{title}</span>
      <Dropdown show={isOpen} onToggle={() => setIsOpen(!isOpen)}>
        <Dropdown.Toggle
          variant="outline"
          id="dropdown-basic"
          className={classNames(
            styles.customToggle,
            {
              // [styles.dropdownDisabled]: disabled,
            },
            className
          )}
          // disabled={disabled}
        >
          <span>{selectedOption.label}</span>
          <img src={downArrow} alt={'Down Arrow'} height={height} />
        </Dropdown.Toggle>
        {isOpen && (
          <Dropdown.Menu className={styles.dropdownMenu}>
            <div className={styles.menuInnerContainer}>
              {options.map((option) => (
                <button
                  aria-label={`select ${option.label}`}
                  key={option.value}
                  className={classNames('w-100 p-0', styles.dropdownItem)}
                >
                  <div className={styles.itemInnerContainer}>
                    <input
                      type="radio"
                      name="options"
                      id={`radio-${option.value}`}
                      value={option.value}
                      checked={selectedOption.value === option.value}
                      onChange={(e) => handleOptionChange(e, option)}
                    />
                    <label
                      className={classNames(styles.inputLabel, {
                        [styles.selectedItem]:
                          selectedOption.value === option.value,
                      })}
                      htmlFor={`radio-${option.value}`}
                    >
                      {option.label}
                    </label>
                  </div>
                </button>
              ))}
            </div>
          </Dropdown.Menu>
        )}
      </Dropdown>
    </div>
  )
}

export default DropdownFilter
